import { motion } from 'framer-motion';

export default function About() {
  return (
    <section className="bg-sand py-20 sm:py-32">
      <div className="max-w-[1100px] mx-auto px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="inline-flex items-center px-5 py-2 border border-gray-400 rounded-full mb-12 sm:mb-20">
            <span className="text-sm font-inter text-gray-700">Sobre o Estúdio</span>
          </div>

          <h2 className="font-playfair font-light text-3xl sm:text-4xl lg:text-6xl text-gray-900 leading-relaxed max-w-4xl mx-auto px-4">
            Projetar em <strong className="font-semibold">Ilhabela</strong> exige conhecimento técnico específico. Trabalhamos com <strong className="font-semibold">terrenos desafiadores</strong>, criando residências integradas à <strong className="font-semibold">paisagem natural</strong>
          </h2>

          <div className="mt-12 sm:mt-16 grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 text-left">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="p-6 sm:p-8 bg-white rounded-2xl"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl mb-4">
                <i className="ri-compass-3-line text-2xl text-accent"></i>
              </div>
              <h3 className="font-inter font-semibold text-base sm:text-lg text-gray-900 mb-3">Análise Técnica</h3>
              <p className="font-inter text-sm text-gray-600 leading-relaxed">
                Estudo detalhado de topografia, insolação, ventilação e legislação local para cada projeto em Ilhabela.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="p-6 sm:p-8 bg-white rounded-2xl"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl mb-4">
                <i className="ri-home-smile-line text-2xl text-accent"></i>
              </div>
              <h3 className="font-inter font-semibold text-base sm:text-lg text-gray-900 mb-3">Projetos Autorais</h3>
              <p className="font-inter text-sm text-gray-600 leading-relaxed">
                Cada residência é única, desenvolvida especialmente para o terreno e o estilo de vida do cliente.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="p-6 sm:p-8 bg-white rounded-2xl sm:col-span-2 md:col-span-1"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl mb-4">
                <i className="ri-plant-line text-2xl text-accent"></i>
              </div>
              <h3 className="font-inter font-semibold text-base sm:text-lg text-gray-900 mb-3">Integração Natural</h3>
              <p className="font-inter text-sm text-gray-600 leading-relaxed">
                Arquitetura que dialoga com a paisagem litorânea, respeitando o entorno e valorizando as vistas.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
